<template>
    <div>
        <v-form ref="regionEditform" v-model="regionEditFormValid" lazy-validation>

            <v-card>
                <v-toolbar dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs12 sm12>
                        <v-text-field 
                            :rules="[rules.required]"
                            v-model="regionData.id" 
                            :disabled="!isNew"
                            label="Region Id"
                            hint="Must be an Unique Value"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field 
                            :rules="[rules.required]"
                            v-model="regionData.name" 
                            label="Name"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                        :rules="[rules.required]"
                        label="Region Manager"
                        v-bind:items="allActiveUsers"
                        v-model="regionData.managerId"
                        item-text="name"
                        item-value="id"
                        hint=""
                        persistent-hint
                        ></v-select>
                    </v-flex>    
                </v-card-text>
                <v-card-actions class="white hide">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="save()">
                    Submit
                    </v-btn>
                    <v-btn class="info" @click="cancel()">
                    Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
        <!-- {{regionData}} -->
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    props: ['id'],
    data () {
        return {
            regionData: {},
            allActiveUsers: [],
            regionEditFormValid: true,
            rules: {
                required: v => !!v || "This field is required"
            },

        }
    },
    computed: {
        // id () {
        //     return this.$route.params.id
        // },
        isNew () {
            return !this.id
        },
        title () {
            return this.isNew?'Add Region' : 'Edit Region'
        }
    },
    methods: {
        ...mapActions('adminMarket', [
            'populateRegionEditModel',
            'saveRegion'
        ]),
        ...mapActions('adminUser', [
            'searchUsers'
        ]),
        async save() {
            if (this.$refs.regionEditform.validate()) {
                var result = await this.saveRegion(this.regionData)
                this.$emit('onCloseRegionEdit')
            }
            // this.$router.push({name: 'admin-regions'})
        },
        cancel() {
            // this causes data reload, even it is not necessary
            this.$emit('onCloseRegionEdit')

            // this.$router.push({name: 'admin-regions'})
        },
    },
    watch: {
        id: async function (newValue) {
            this.regionData = await this.populateRegionEditModel(newValue)

        }
    },
    async created () {
        this.regionData = await this.populateRegionEditModel(this.id)
        this.allActiveUsers = await this.searchUsers({active:true})
    }
}
</script>
